export default {
    ws: {},
    socketReconnectTimer: null, // 计时器对象——重连
    socketReconnectLock: false, // WebSocket重连的锁
    socketLeaveFlag: false, // 离开标记（解决 退出登录再登录 时出现的 多次相同推送 问题，出现的本质是多次建立了WebSocket连接）
    setWs: function(news) {
      this.ws = news
    },
    //心跳检测
    heartCheck: {
      vueThis: this, // vue实例
      timeout: 60000, // 心跳发送时间
      heartTimeout: null,// 心跳检测时间
      timeoutObj: null, // 计时器对象——向后端发送心跳检测
      serverTimeoutObj: null, // 计时器对象——等待后端心跳检测的回复
      // 心跳检测重置
      reset: function () {
        clearTimeout(this.heartTimeout);
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        return this;
      },
      // 心跳检测启动
      start: function (gws) {
        this.heartTimeout && clearTimeout(this.heartTimeout);
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(() => {
          // 这里向后端发送一个心跳检测，后端收到后，会返回一个心跳回复
          gws.send("ping");
          console.log("发送心跳检测");
          this.serverTimeoutObj = setTimeout(() => {
            // 如果超过一定时间还没重置计时器，说明websocket与后端断开了
            console.log("未收到心跳检测回复");
            this.heartTimeout = setTimeout(() => {
              // 关闭WebSocket
              gws.close();
              console.log("未收到心跳检测回复-websocket已关闭");
            }, 10000)
          }, this.timeout);
        }, this.timeout);
      },
    }
  }